import { Lock } from '@mui/icons-material';
import { Divider, IconButton, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { EditIcon } from '../../../../assets';
import { WidgetsIcon } from '../../../../assets/dashboard';

interface DashboardHeaderProps {
  isEditMode: boolean;
  loading?: boolean;
  onToggleEditMode?: () => void;
}
export function DashboardHeader({
  isEditMode,
  loading,
  onToggleEditMode,
}: DashboardHeaderProps) {
  const { t } = useTranslation();
  return (
    <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
      <Typography variant="h6" fontWeight={600}>
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            marginRight: 8,
          }}
        >
          <WidgetsIcon />
        </span>
        {t('device.menu.overview')}
      </Typography>

      <Divider sx={{ flexGrow: 1 }} />

      <IconButton onClick={onToggleEditMode} loading={loading}>
        {isEditMode ? <Lock /> : <EditIcon />}
      </IconButton>
    </Stack>
  );
}

export default DashboardHeader;
